import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiTextfieldControllerModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiActiveZone } from '@taiga-ui/cdk';
import { TuiDataList, TuiGroup, TuiDropdown, TuiButton } from '@taiga-ui/core';
import { TuiTabs } from '@taiga-ui/kit';
import { TuiDropdownMobile } from '@taiga-ui/addon-mobile';
import { ComponentsModule } from '@src/app/components';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';

import { CustomNamesTabsComponent } from './custom-names-tabs.component';
import { CustomNameComponent } from './components/custom-name/custom-name.component';
import { CustomNamesPipe } from './pipes/custom-names.pipe';

@NgModule({
  declarations: [CustomNamesTabsComponent, CustomNameComponent, CustomNamesPipe],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ...TuiDropdown,
    TuiTextfieldControllerModule,
    ...TuiDataList,
    ...TuiTabs,
    TuiButton,
    TuiActiveZone,
    IconModule,
    TuiDropdownMobile,
    TuiGroup,
    TuiInputModule,
  ],
  providers: [CustomNamesPipe],
  exports: [CustomNamesTabsComponent, CustomNamesPipe],
})
export class CustomNamesTabsModule {}
